"use strict";
var fails = require("../internals/fails");
var globalThis = require("../internals/global-this");
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
  var re = $RegExp("(?<a>b)", "g");
  return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
